// // import React from 'react';
// // import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, IconButton, Box, Typography } from '@mui/material';
// // import { Close as CloseIcon } from '@mui/icons-material';

// // const ConfirmDialog = ({ confirmOpen, setConfirmOpen, error, confirmSaveCourse }) => {
// //     return (
// //         <Dialog
// //             open={confirmOpen}
// //             onClose={() => setConfirmOpen(false)}
// //             maxWidth="sm"
// //             fullWidth
// //             sx={{ borderRadius: '12px' }}
// //         >
// //             <DialogTitle
// //                 sx={{
// //                     display: 'flex',
// //                     justifyContent: 'space-between',
// //                     alignItems: 'center',
// //                     borderBottom: '1px solid #E7E8E9',
// //                     padding: '10px 24px',
// //                 }}
// //             >
// //                 <Typography variant="h6">Confirm Assignment</Typography>
// //                 <IconButton edge="end" color="inherit" onClick={() => setConfirmOpen(false)}>
// //                     <CloseIcon />
// //                 </IconButton>
// //             </DialogTitle>
// //             {error && (
// //                 <Box sx={{ backgroundColor: "#ffebee", color: "#c62828", p: 1.5, textAlign: "center", mb: 2, borderRadius: '8px' }}>
// //                     {error}
// //                 </Box>
// //             )}
// //             <DialogContent className="my-4 text-center">
// //                 <img
// //                     src="/images/queMark.png"
// //                     alt="Warning"
// //                     style={{ width: 60, height: 60, marginBottom: 16 }}
// //                 />
// //                 <DialogContentText>Are you sure you want to assign this Assessment?</DialogContentText>
// //             </DialogContent>
// //             <DialogActions
// //                 sx={{
// //                     padding: '1rem',
// //                     borderTop: '1px solid #E7E8E9',
// //                     justifyContent: 'center',
// //                 }}
// //             >
// //                 <button className="btn" onClick={confirmSaveCourse}>
// //                     Confirm
// //                 </button>
// //                 <button className="btn-negative" onClick={() => setConfirmOpen(false)}>
// //                     Cancel
// //                 </button>
// //             </DialogActions>
// //         </Dialog>
// //     );
// // };

// // export default ConfirmDialog;


// // src/HR/Assign_Course/dialogs/ConfirmDialog.jsx
// import React from 'react';
// import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, IconButton, Box, Typography } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';

// const ConfirmDialog = ({ 
//     confirmOpen, 
//     setConfirmOpen, 
//     error, 
//     confirmSaveCourse,
//     isMobile,
//     // New props for error handling
//     setRescheduleDialogOpen,
//     setRescheduleDialogData,
//     setErrorDialogOpen,
//     setErrorDialogData
// }) => {
//     const handleConfirm = () => {
//         confirmSaveCourse(
//             setRescheduleDialogOpen,
//             setRescheduleDialogData,
//             setErrorDialogOpen,
//             setErrorDialogData
//         );
//     };

//     return (
//         <Dialog
//             open={confirmOpen}
//             onClose={() => setConfirmOpen(false)}
//             maxWidth="sm"
//             fullWidth
//             sx={{ borderRadius: '12px' }}
//         >
//             <DialogTitle
//                 sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'center',
//                     borderBottom: '1px solid #E7E8E9',
//                     padding: '10px 24px',
//                 }}
//             >
//                 <Typography variant="h6">Confirm Assignment</Typography>
//                 <IconButton edge="end" color="inherit" onClick={() => setConfirmOpen(false)}>
//                     <CloseIcon />
//                 </IconButton>
//             </DialogTitle>
//             {error && (
//                 <Box sx={{ backgroundColor: "#ffebee", color: "#c62828", p: 1.5, textAlign: "center", mb: 2, borderRadius: '8px' }}>
//                     {error}
//                 </Box>
//             )}
//             <DialogContent className="my-4 text-center">
//                 <img
//                     src="/images/queMark.png"
//                     alt="Warning"
//                     style={{ width: 60, height: 60, marginBottom: 16 }}
//                 />
//                 <DialogContentText>Are you sure you want to assign this Assessment?</DialogContentText>
//             </DialogContent>
//             <DialogActions
//                 sx={{
//                     padding: '1rem',
//                     borderTop: '1px solid #E7E8E9',
//                     justifyContent: 'center',
//                 }}
//             >
//                 <button className="btn" onClick={handleConfirm}>
//                     Confirm
//                 </button>
//                 <button className="btn-negative" onClick={() => setConfirmOpen(false)}>
//                     Cancel
//                 </button>
//             </DialogActions>
//         </Dialog>
//     );
// };

// export default ConfirmDialog;


// src/HR/Assign_Course/dialogs/ConfirmDialog.jsximport React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, IconButton, Box, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ConfirmDialog = ({
    confirmOpen,
    setConfirmOpen,
    error,
    confirmSaveCourse,
    isMobile
}) => {
    const handleConfirm = async () => {
        if (error) return;
        // Close the confirm dialog
        setConfirmOpen(false);
        // Call the save function
        await confirmSaveCourse();
    };

    return (
        <Dialog
            open={confirmOpen}
            onClose={() => setConfirmOpen(false)}
            maxWidth="sm"
            fullWidth
            sx={{ borderRadius: '12px' }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #E7E8E9',
                    padding: '10px 24px',
                }}
            >
                <Typography variant="h6">Confirm Assignment</Typography>
                <IconButton edge="end" color="inherit" onClick={() => setConfirmOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {error && (
                <Box sx={{ backgroundColor: "#ffebee", color: "#c62828", p: 1.5, textAlign: "center", mb: 2, borderRadius: '8px' }}>
                    {error}
                </Box>
            )}
            <DialogContent className="my-4 text-center">
                <img
                    src="/images/queMark.png"
                    alt="Warning"
                    style={{ width: 60, height: 60, marginBottom: 16 }}
                />
                <DialogContentText>Are you sure you want to assign this Assessment?</DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    padding: '1rem',
                    borderTop: '1px solid #E7E8E9',
                    justifyContent: 'center',
                }}
            >
                {/* <button className="btn" onClick={handleConfirm}>
                    Confirm
                </button> */}
                <button
                    className="btn"
                    onClick={handleConfirm}
                    disabled={!!error}
                    style={{
                        opacity: error ? 0.5 : 1,
                        cursor: error ? "not-allowed" : "pointer"
                    }}
                >
                    Confirm
                </button>
                <button className="btn-negative" onClick={() => setConfirmOpen(false)}>
                    Cancel
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;